export default "__VITE_ASSET__$OFIAezv__"